import React from 'react'
import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
import cls from './styles.scss'

const cx = _cx.bind(cls)

const draws = [
  'M1.52,126.52q.25,2,.6,4l23.66-4c-.18-1-.33-2.06-.47-3.1Z',
  'M24.57,114l-24,.61c0,1.33.09,2.67.17,4l24-1.46C24.64,116.11,24.6,115.06,24.57,114Z',
  'M24.83,104.63.91,102.7c-.11,1.32-.19,2.65-.25,4l24,1.08C24.68,106.72,24.75,105.67,24.83,104.63Z',
  'M1.84,94.74l23.72,3.65c.16-1,.34-2.06.53-3.09L2.52,90.8C2.27,92.1,2,93.42,1.84,94.74Z',
  'M4.3,83l23.19,6.2c.27-1,.56-2,.86-3l-22.94-7Q4.82,81.07,4.3,83Z',
  'M8,71.58l22.37,8.69c.38-1,.77-1.94,1.19-2.9l-22-9.49C9,69.1,8.52,70.33,8,71.58Z',
  'M13,60.66l21.3,11.06c.48-.93,1-1.85,1.49-2.76L14.89,57.14C14.23,58.3,13.59,59.47,13,60.66Z',
  'M19.09,50.3l20,13.31c.58-.87,1.17-1.73,1.78-2.58L21.37,47C20.59,48.1,19.83,49.19,19.09,50.3Z',
  'M26.29,40.67,44.71,56.05c.67-.8,1.36-1.6,2.06-2.37l-17.87-16C28,38.64,27.14,39.65,26.29,40.67Z',
  'M34.42,31.93,51.09,49.18c.76-.72,1.52-1.44,2.3-2.14l-16-17.84C36.35,30.09,35.38,31,34.42,31.93Z',
  'M43.49,24.06,58.21,43c.83-.64,1.67-1.27,2.52-1.88l-14-19.47C45.61,22.44,44.54,23.24,43.49,24.06Z',
  'M53.36,17.21,66,37.64c.89-.55,1.79-1.09,2.69-1.6L56.8,15.17C55.64,15.83,54.49,16.51,53.36,17.21Z',
  'M63.92,11.46,74.23,33.13q1.41-.68,2.85-1.29l-9.52-22C66.34,10.34,65.12,10.89,63.92,11.46Z',
  'M75,6.89l7.89,22.67c1-.34,2-.67,3-1L78.84,5.65C77.57,6,76.3,6.46,75,6.89Z',
  'M86.61,3.57,92,27c1-.24,2-.45,3.06-.65L90.52,2.74C89.21,3,87.9,3.27,86.61,3.57Z',
  'M98.46,1.52l2.8,23.83c1-.12,2.07-.22,3.12-.31L102.44,1.12C101.1,1.23,99.77,1.36,98.46,1.52Z',
  'M111.54.75h-1.25l.27,24h1c1.06,0,1.21,0,2.26.06l.84-24c-.88,0-.87,0-1.76-.06Z',
  'M120,25c1,.09,2.08.19,3.12.32l2.8-23.84c-1.32-.16-2.64-.29-4-.4Z',
  'M129.35,26.3c1,.2,2,.42,3.06.65l5.37-23.39c-1.3-.3-2.6-.57-3.91-.83Z',
  'M145.54,5.64l-7.06,22.94c1,.31,2,.63,3,1l7.88-22.66C148.09,6.45,146.82,6,145.54,5.64Z',
  'M156.83,9.8l-9.52,22c1,.42,1.91.85,2.85,1.3l10.31-21.68C159.27,10.88,158.05,10.33,156.83,9.8Z',
  'M167.59,15.16,155.73,36c.91.52,1.81,1,2.7,1.6L171,17.2C169.9,16.5,168.75,15.82,167.59,15.16Z',
  'M177.7,21.65l-14,19.47c.85.61,1.69,1.24,2.51,1.88L180.9,24.05C179.85,23.23,178.78,22.43,177.7,21.65Z',
  'M187.05,29.19,171,47c.77.7,1.54,1.41,2.29,2.14L190,31.92C189,31,188,30.08,187.05,29.19Z',
  'M195.48,37.64l-17.86,16c.7.78,1.38,1.57,2.06,2.37L198.1,40.66C197.25,39.64,196.37,38.63,195.48,37.64Z',
  'M203,47,183.53,61c.62.85,1.21,1.71,1.79,2.58l20-13.3C204.56,49.18,203.8,48.09,203,47Z',
  'M209.5,57.13,188.62,69c.51.91,1,1.82,1.49,2.75l21.3-11.06C210.79,59.46,210.16,58.29,209.5,57.13Z',
  'M214.83,67.87l-22,9.49c.42,1,.81,1.93,1.19,2.9l22.37-8.69C215.87,70.33,215.36,69.09,214.83,67.87Z',
  'M219,79.15l-22.94,7c.3,1,.59,2,.86,3L220.08,83C219.74,81.7,219.37,80.42,219,79.15Z',
  'M222.55,94.73c-.21-1.32-.43-2.64-.68-3.94l-23.58,4.5q.3,1.54.54,3.09Z',
  'M199.75,107.76l24-1.08c-.06-1.33-.14-2.67-.25-4l-23.92,1.93C199.64,105.66,199.71,106.71,199.75,107.76Z',
  'M199.81,114c0,1-.07,2.1-.13,3.14l24,1.46c.08-1.32.13-2.65.17-4Z',
  'M198.61,126.45l23.66,4c.22-1.31.42-2.63.6-4l-23.79-3.17C198.94,124.39,198.78,125.42,198.61,126.45Z',
]

const Gauge = ({ percentage }) => {
  const upTo = Math.floor(percentage * 0.32)

  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 225 140'>
      {draws.map((draw, index) => (
        <path
          key={draw}
          className={cx(upTo >= index ? `bar-${index + 1}` : 'bar-off')}
          d={draw}
        />
      ))}
    </svg>
  )
}

Gauge.propTypes = {
  percentage: PropTypes.number,
}

export default Gauge
